/** Chữ của "In hoá đơn" và "Máy in" (web quầy). Tiếng Việt có dấu, câu ngắn, không thuật ngữ IT. */
export const IN = {
  nutIn: 'In hoá đơn',
  dangIn: 'Đang in…',
  daIn: 'Đã gửi lệnh in',
  nutMayIn: 'Máy in',
  chiIn: 'Chỉ in được hoá đơn đã thu tiền.',

  // Nội dung tờ in
  soHoaDon: 'Số',
  ngay: 'Ngày',
  khach: 'Khách',
  thuNgan: 'Thu ngân',
  tamTinh: 'Tạm tính',
  giam: 'Giảm giá',
  tong: 'TỔNG CỘNG',
  daTraBang: 'Đã trả',
  truGoi: 'Trừ gói',
  camOn: 'Cảm ơn quý khách!',
  khachLe: 'Khách lẻ',
  /** Câu cố định cuối tờ (giai đoạn này chỉ dừng ở đây; xuất hoá đơn điện tử là kế hoạch sau). */
  hoaDonDienTu: (sdt: string | null) =>
    `Nếu cần xuất hoá đơn điện tử, vui lòng liên hệ ${sdt ?? 'chủ tiệm'} trong vòng 24 giờ để được xuất.`,

  // Cài đặt máy in
  tieuDeMayIn: 'Máy in hoá đơn',
  giaiThichMayIn:
    'Cài riêng cho từng thiết bị (tablet ở quầy, điện thoại…). Lưu ngay khi bạn chọn.',
  cachIn: 'Cách in',
  kieuTrinhDuyet: 'Máy in của thiết bị',
  kieuTrinhDuyetMoTa:
    'Dùng khi máy in đã được thêm vào Windows, Android hoặc iPad — kể cả máy in WiFi, USB hay Bluetooth. Bấm "In" là hiện hộp chọn máy in.',
  kieuUsb: 'Cắm dây USB',
  kieuUsbMoTa: 'Nối thẳng máy in nhiệt bằng dây USB (Chrome trên máy tính hoặc Android).',
  kieuBluetooth: 'Bluetooth',
  kieuBluetoothMoTa: 'Máy in nhiệt cầm tay hoặc để bàn có Bluetooth. Bấm "Quét" để tìm và ghép.',
  khoGiay: 'Khổ giấy',
  kho58: '58 mm',
  kho80: '80 mm',
  thietBiDaNoi: (ten: string) => `Đã nối: ${ten}`,
  chuaNoi: 'Chưa nối máy in nào.',
  quetBluetooth: 'Quét máy in Bluetooth',
  noiUsb: 'Chọn máy in USB',
  doiThietBi: 'Chọn máy khác',
  inThu: 'In thử',
  dangNoi: 'Đang nối…',
  noiXong: 'Đã nối máy in.',
  khongHoTroBluetooth:
    'Trình duyệt này không tìm được thiết bị Bluetooth. Bạn dùng Chrome, hoặc chọn "Máy in của thiết bị".',
  khongHoTroUsb:
    'Trình duyệt này không nối được cổng USB. Bạn dùng Chrome, hoặc chọn "Máy in của thiết bị".',
  huyChon: 'Bạn chưa chọn máy in.',
  khongTimThayCong:
    'Không mở được máy in này. Nếu là máy tính Windows, bạn thử "Máy in của thiết bị" nhé.',
  khongGhiDuoc: 'Chưa in được. Bạn kiểm tra máy in đã bật và còn giấy, rồi thử lại nhé.',
  wifiGhiChu:
    'Máy in WiFi: thêm máy in vào Windows / Android như bình thường, rồi chọn "Máy in của thiết bị" ở trên.',
  tenThuNghiem: 'HOÁ ĐƠN IN THỬ',
  inThuDong: 'Máy in đã nối và in được tiếng Việt có dấu.',
} as const
